import { MyDealer, useFaContent } from 'src/feature-app';
import { useFeatureServices } from 'src/feature-app/hooks/use-feature-services';

export const useGetKvps = (paramkvps?: string) => {
	const faContent = useFaContent();
	const urlParams = new URLSearchParams(window.location.search);
	const dealerParam = urlParams.get('dealer');
	const kvpsParam = urlParams.get('kvps');
	const myDealerIdParam = urlParams.get('myDealerId');
	const myDealer = useFeatureServices()['mydealer-service'] as MyDealer;
	const myDealerKvps = myDealer?.currentDealer?.id;

	let isMyCurrentDealer = false;
	let kvps = null;

	if (paramkvps) {
		kvps = paramkvps;
	} else if (faContent?.dealer) {
		kvps = faContent?.dealer;
	} else if (kvpsParam) {
		kvps = kvpsParam;
	} else if (dealerParam) {
		kvps = dealerParam;
	} else if (myDealerKvps) {
		isMyCurrentDealer = true;
		kvps = myDealerKvps;
	} else if (myDealerIdParam) {
		isMyCurrentDealer = true;
		kvps = myDealerIdParam;
	}

	return { kvps, isMyCurrentDealer };
};
